module.exports = fox._r("images/trans.gif", __webpack_public_path__ + "images/trans.gif");


//////////////////
// WEBPACK FOOTER
// ./images/trans.gif
// module id = 1132
// module chunks = 4